import { AbstractTextHighlighter } from './AbstractTextHighlighter';
import { HighlighterId } from './Highlighter';

export class TextFilterHighlighter extends AbstractTextHighlighter {
  static get id(): HighlighterId {
    return 'textFilterHighlighter';
  }

  get id(): HighlighterId {
    return TextFilterHighlighter.id;
  }
}
